import { useEffect, useMemo } from 'react'

import { useQuery } from 'react-query'

import { usePagination } from '@webapp/core/hooks/usePagination'
import { AuditLogRecord } from '@webapp/platform/audit-log/entities/AuditLogRecord'
import { auditLogQueryConfig } from '../../../query-configs/auditLog'

export const useQueryAuditLog = ({
  contentTypeId,
  objectId,
}: {
  contentTypeId: number
  // Omitted → module-wide log for the content type (BHV-030)
  objectId?: string
}) => {
  const { params, updateNumPages } = usePagination({
    id: 'audit-log',
  })

  const { data, isFetching, isLoading, isSuccess } = useQuery({
    ...auditLogQueryConfig.getAuditLog({
      contentTypeId,
      objectId,
      paginationParams: params,
    }),
  })

  useEffect(() => {
    if (isSuccess && data) {
      updateNumPages(data.pagination.numPages)
    }
  }, [isSuccess, data])

  const auditLog = useMemo(() => {
    return data?.data
      ? data.data.map((auditLogRecord) => new AuditLogRecord(auditLogRecord))
      : []
  }, [data])

  return {
    auditLog,
    pagination: data?.pagination,
    isFetching,
    isLoading,
  }
}
